import { ApiService } from 'services';
import { handleException } from 'actions/exceptions';

export const DELETE_FORMS_REQUEST = 'DELETE_FORMS_REQUEST';
export const DELETE_FORMS_SUCCESS = 'DELETE_FORMS_SUCCESS';
export const DELETE_FORMS_FAILURE = 'DELETE_FORMS_FAILURE';

function requestDeleteForms() {
  return {
    type: DELETE_FORMS_REQUEST,
    isDeletingForms: true,
    deleteFormsResponse: null
  };
}

function receiveDeleteForms(deleteFormsResponse) {
  return {
    type: DELETE_FORMS_SUCCESS,
    isDeletingForms: false,
    deleteFormsResponse,
    deleteFormsError: null
  };
}

function rejectDeleteForms(deleteFormsError) {
  return {
    type: DELETE_FORMS_FAILURE,
    isDeletingForms: false,
    deleteFormsResponse: null,
    deleteFormsError
  };
}

export function deleteForms(forms, callback) {
  const formData = new FormData();
  formData.append('', forms);
  return (dispatch) => {
    dispatch(requestDeleteForms(forms));

    const promise = () => ApiService
      .deleteForms(forms)
      .then((response) => {
        dispatch(receiveDeleteForms(response.data));
        if (callback) {
          callback();
        }
      })
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }
        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, rejectDeleteForms, true));
        }
      });
    return promise();
  };
}
